/* Imports */
import React from 'react'

/* Functional Component */
function Text(props) {
  return (
    <span className='text-darkPurple text-xs'>{props.text}</span>
  )
}

/* Exports */
export default Text